<template>
  <div>
    <Breadcrumbs main="" title="firebase users"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header firebase-header">
              <h5>User List (Firebase)</h5>
            </div>

            <div class="card-body custom-scrollbar">
              <div class="todo">
                <div class="todo-list-wrapper">
                  <div class="todo-list-container">
                    <div class="table-responsive datatable-vue m-0 vue-smart">                                      
                      <v-table
                          :data="noticeList" class="table"
                          :currentPage.sync="basic.currentPage"
                          :pageSize="10"
                          @totalPagesChanged="basic.totalPages = $event"
                      >

                        <thead slot="head">
                          <th class="text-center">ID</th>
                          <th class="text-center">Name</th>
                          <th class="text-center">Type</th>
                          <th class="text-center">Level</th>
                          <th class="text-center">Access</th>
                          <th class="text-center">Star</th>
                          <th class="text-center">Gold</th>
                          <th class="text-center">Login</th>
                          <th class="text-center">Join</th>
                          <th class="text-center">Status</th>
                          <th class="text-center">Del</th>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                          <tr v-for="(todo, index) in displayData" :key="index" class="task" :class="{'completed':todo.status == 'ACTIVE'}">
                            <td class="text-center">{{ todo.userUid }}</td>
                            <td class="text-center">{{ todo.userName }}<img :src="`${todo.userPhotoUrl}`" :title="todo.userPhotoUrl" :width="30"></td>  
                            <td class="text-center">
                                <b-div v-if="todo.userType=='NORMAL'"><b-badge pill variant="success">{{ todo.userType }}</b-badge></b-div>
                                <b-div v-else-if="todo.userType=='ABUSER'"><b-badge pill variant="secondary">{{ todo.userType }}</b-badge></b-div>
                                <b-div v-else><b-badge pill variant="primary">{{ todo.userType }}</b-badge></b-div>
                            </td> 
                            <td class="text-center">{{ todo.level }}</td> 
                            <td class="text-center">
                              <span @click="accessActiveArena(todo.id, todo.accessStatus.arena)" class="action-box large complete-btn" title="Arena">
                                <b-div v-if="todo.accessStatus.arena==true"><b-badge pill variant="success"><v-icon class="fa fa-gamepad" style="font-size:15px;"></v-icon></b-badge></b-div>
                                <b-div v-else><b-badge pill variant="secondary"><v-icon class="fa fa-gamepad" style="font-size:15px;"></v-icon></b-badge></b-div>
                              </span>
                              <span @click="accessActiveCoupon(todo.id, todo.accessStatus.coupon)" class="action-box large complete-btn" title="Coupon">
                                <b-div v-if="todo.accessStatus.coupon==true"><b-badge pill variant="success"><v-icon class="fa fa-ticket" style="font-size:15px;"></v-icon></b-badge></b-div>
                                <b-div v-else><b-badge pill variant="secondary"><v-icon class="fa fa-ticket" style="font-size:15px;"></v-icon></b-badge></b-div>
                              </span>
                              <span @click="accessActiveGift(todo.id, todo.accessStatus.gift)" class="action-box large complete-btn" title="Gift">
                                <b-div v-if="todo.accessStatus.gift==true"><b-badge pill variant="success"><v-icon class="fa fa-gift" style="font-size:15px;"></v-icon></b-badge></b-div>
                                <b-div v-else><b-badge pill variant="secondary"><v-icon class="fa fa-gift" style="font-size:15px;"></v-icon></b-badge></b-div>
                              </span>
                              <span @click="accessActiveMail(todo.id, todo.accessStatus.mail)" class="action-box large complete-btn" title="Mail">
                                <b-div v-if="todo.accessStatus.mail==true"><b-badge pill variant="success"><v-icon class="fa fa-envelope-o" style="font-size:15px;"></v-icon></b-badge></b-div>
                                <b-div v-else><b-badge pill variant="secondary"><v-icon class="fa fa-envelope-o" style="font-size:15px;"></v-icon></b-badge></b-div>
                              </span>
                              <span @click="accessActiveRank(todo.id, todo.accessStatus.rank)" class="action-box large complete-btn" title="Rank">
                                <b-div v-if="todo.accessStatus.rank==true"><b-badge pill variant="success"><v-icon class="fa fa-group" style="font-size:15px;"></v-icon></b-badge></b-div>
                                <b-div v-else><b-badge pill variant="secondary"><v-icon class="fa fa-group" style="font-size:15px;"></v-icon></b-badge></b-div>
                              </span>
                              <span @click="accessActiveTalk(todo.id, todo.accessStatus.talk)" class="action-box large complete-btn" title="Talk">
                                <b-div v-if="todo.accessStatus.talk==true"><b-badge pill variant="success"><v-icon class="fa fa-comments" style="font-size:15px;"></v-icon></b-badge></b-div>
                                <b-div v-else><b-badge pill variant="secondary"><v-icon class="fa fa-comments" style="font-size:15px;"></v-icon></b-badge></b-div>
                              </span>
                            </td>                              
                            <td class="text-center">{{ todo.goods.star }}</td>
                            <td class="text-center">{{ todo.goods.gold }}</td>
                            <td class="text-center"><b-badge pill variant="success">{{ todo.loginDate }}</b-badge></td>
                            <td class="text-center"><b-badge pill variant="success">{{ formatDate(todo.joinDate) }}</b-badge></td>
                            <td class="text-center">
                              <span @click="taskActive(todo.id, todo.status)" class="action-box large complete-btn" title="Change status">
                                <b-badge v-if="todo.status=='INACTIVE'" pill variant="secondary"><i class="icon-check"></i>{{ todo.status }}</b-badge>
                                <b-badge v-else pill variant="success"><i class="icon-check"></i>{{ todo.status }}</b-badge>
                              </span>  
                            </td>
                            <td class="text-center">
                              <span class="task-action-btn">
                                <span @click="tododelete(todo.id, todo.status)" class="action-box large delete-btn" title="Delete Task"><i class="icon"><i class="icon-trash"></i></i></span>
                              </span>                            
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                      <smart-pagination
                          :currentPage.sync="basic.currentPage"
                          :totalPages="basic.totalPages"
                      />
                    </div>
                  </div>
                </div>
                <div><notifications classes="task" group="noticeList" /></div>
              </div>
            </div>
          </div>                
        </div>

        

        <div class="col-xl-12"> 
          <div class="default-according">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="div" role="tab" class="bg-secondary">
                <h5 class="mb-0">
                  <b-button v-b-toggle.sectionHowto><i class="fa fa-question-circle"></i> Howto <span class="digits"></span></b-button>
                </h5>
              </b-card-header>
              <b-collapse id="sectionHowto" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  1. User의 Type은 NORMAL, VIP1, VIP2, VIP3, VIP4, ABUSER로 구분됩니다.<br>
                  2. Access는 세부즉으로 arena, coupon, gift, mail, rank, talk에 대한 접근 여부를 개별적으로 설정 할 수 있습니다.<br>
                  3. User의 Status는 ACTIVE, INACTIVE로 구분됩니다.<br>
                  4. 한번 삭제된 User 정보는 복구 불가능 합니다. 삭제 전에 한번더 확인 해주시기 바랍니다.
                </b-card-body>
              </b-collapse>
            </b-card>                                                                    
          </div>
        </div>  

      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>



<script>
  import { mapState } from "vuex";
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment'  

  export default{
    name:'todo',
    data(){
      return{
        format: "yyyy/MM/dd",

        basic:{
          currentPage: 1,
          totalPages: 0,
        },

        filter:{
          currentPage: 1,
          totalPages: 0,
        },

        selectrow:{
          currentPage: 1,
          totalPages: 0,
        },

        filters: {
            userUid: { value: '', keys: ['userUid'] },
            userType: { value: '', keys: ['userType'] },
            userName: { value: '', keys: ['userName'] },
            userPhotoUrl: { value: '', keys: ['userPhotoUrl'] },
            level: { value: '', keys: ['level'] },
            country: { value: '', keys: ['country'] },
            language: { value: '', keys: ['language'] },
            goods: { value: '', keys: ['goods'] }, 
            accessStatus: { value: '', keys: ['accessStatus'] },
            loginDate: { value: '', keys: ['loginDate'] },
            joinDate: { value: '', keys: ['joinDate'] },
            status: { value: '', keys: ['status'] }
        }
      }
      
    },
    components: {
      Datepicker
    },

    computed:{
      ...mapState({
        noticeList: state => state.firebase_user.todo,
      }),

      formatted(){
        return Vue.filter('todo.created')(this.value)
      }
    },

    created(){
      this.$store.dispatch('firebase_user/retrieveTodos')
      this.retrieveTodos();
    },    

    methods:{
      getImgUrl(filename) {
        var images = require.context('../../assets/images/market/', false, /\.png$/)
        return images('./' + filename)
      }, 

      // methods area
      formatDate: function(dt){
        return moment(dt).fromNow();//format('YYYY-MM-DD hh:mm');
      },

      formatDateChecked: function(dt){      
        return moment(String(dt.toDate())).format('YYYY-MM-DD hh:mm')
      },

      retrieveTodos()
      {        
        this.$store.dispatch('firebase_user/retrieveTodos')
      },

      accessActiveArena(id, accessPart)
      {
        this.$store.dispatch('firebase_user/accessActiveArena', id)
        this.retrieveTodos();

        if(accessPart == false)
          this.$toasted.show("Arena access changed to true.", {theme: 'outline', type: 'success', duration: 2000});
        else
          this.$toasted.show("Arena access changed to false", {theme: 'outline', type: 'error', duration: 2000});
      },
      accessActiveCoupon(id, accessPart)
      {
        this.$store.dispatch('firebase_user/accessActiveCoupon', id)
        this.retrieveTodos();

        if(accessPart == false)
          this.$toasted.show("Coupon access changed to true.", {theme: 'outline', type: 'success', duration: 2000});
        else
          this.$toasted.show("Coupon access changed to false", {theme: 'outline', type: 'error', duration: 2000});
      },
      accessActiveGift(id, accessPart)
      {
        this.$store.dispatch('firebase_user/accessActiveGift', id)
        this.retrieveTodos();

        if(accessPart == false)
          this.$toasted.show("Gift access changed to true.", {theme: 'outline', type: 'success', duration: 2000});
        else
          this.$toasted.show("Gift access changed to false", {theme: 'outline', type: 'error', duration: 2000});
      },
      accessActiveMail(id, accessPart)
      {
        this.$store.dispatch('firebase_user/accessActiveMail', id)
        this.retrieveTodos();

        if(accessPart == false)
          this.$toasted.show("Mail access changed to true.", {theme: 'outline', type: 'success', duration: 2000});
        else
          this.$toasted.show("Mail access changed to false", {theme: 'outline', type: 'error', duration: 2000});
      },
      accessActiveRank(id, accessPart)
      {
        this.$store.dispatch('firebase_user/accessActiveRank', id)
        this.retrieveTodos();

        if(accessPart == false)
          this.$toasted.show("Rank access changed to true.", {theme: 'outline', type: 'success', duration: 2000});
        else
          this.$toasted.show("Rank access changed to false", {theme: 'outline', type: 'error', duration: 2000});
      },
      accessActiveTalk(id, accessPart)
      {
        this.$store.dispatch('firebase_user/accessActiveTalk', id)
        this.retrieveTodos();

        if(accessPart == false)
          this.$toasted.show("Talk access changed to true.", {theme: 'outline', type: 'success', duration: 2000});
        else
          this.$toasted.show("Talk access changed to false", {theme: 'outline', type: 'error', duration: 2000});
      },                              

      taskActive(id, status)
      {
        this.$store.dispatch('firebase_user/taskActive', id)
        this.retrieveTodos();

        if(status == "INACTIVE")
          this.$toasted.show("Notice marked as ACTIVE.", {theme: 'outline', type: 'success', duration: 2000});
        else
          this.$toasted.show("Notice marked as INACTIVE.", {theme: 'outline', type: 'error', duration: 2000});
      },

      tododelete(id, status)
      {
        if(status == "INACTIVE")
        {
          this.$store.dispatch('firebase_user/tododelete', id)
          this.retrieveTodos();
          this.$toasted.show("Notice has been deleted.",{theme:'outline', type : 'success',duration:2000});
        }
        else
        {
          this.$toasted.show("Notice is ACTIVE status, change to INACTIVE before delete.",{theme:'outline', type : 'error',duration:2000});
        }
      }
    }
  }
</script>
